import { R } from "./colors";

export const shapeTheme = {
  borderRadius: R.ctl,
};
